'use strict';

angular.module('app.translations', [])
    .controller('translationsCtrl', ['$scope', '$rootScope', '$modal', '$http', 'translationsService', 'adminService', 'mentionManagementService',
        function ($scope, $rootScope, $modal, $http, translationsService, adminService, mentionManagementService) {
            $scope.specificLanguages = [];
		    $scope.translateLanguages = [];
		    $scope.preLoaded = false;
		    $scope.specificMentionList = [];
		    $scope.translateMentions = [];
		    $scope.currentPage = 1;
		    $scope.selectedSpecificLanguageId = 0;
		    $scope.selectedTranslateLanguageId = 0;
		    $scope.pageSize = 25;
		    $scope.number = 0;
		    $scope.checkedMentionList = [];
		    $scope.enableWatch = false;
		    $scope.currentUrl = $rootScope.apiUrl + 'mention/findSpecificMentionList';

		    mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function(responseGetmentionLanguages) {
                	responseGetmentionLanguages.data.splice(0, 1);
                    $scope.specificLanguages = responseGetmentionLanguages.data;
                    $scope.specificLanguages[0].ticked = true;
                    mentionManagementService.getLanguagesOfInterestingCountries(false)
		                .then(function(response) {
		                	response.data.splice(0, 1);
		                    angular.forEach(response.data, function(item) {                
		                        if(item.id != $scope.specificLanguages[0].id) {
		                            item.ticked = false;
		                            $scope.translateLanguages.push(item);
		                        }
		                    })

		                    $scope.translateLanguages[0].ticked = true;
		                    if(!$scope.preLoaded) {     
		                        $scope.selectedSpecificLanguageId = $scope.specificLanguages[0].id;
		                        $scope.selectedTranslateLanguageId = $scope.translateLanguages[0].id;   
		                        $scope.loadData();
		                    }


		                }, function(errResponse) {
		                    var errorModalInstance = $modal.open({
		                        scope: $scope,
		                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                        windowClass: 'modal-dialog-mention-error'
		                    });
		                    $scope.errorModalInstance = errorModalInstance;
		                    $scope.errorMessage = errResponse.message;
		                })
                }, function(responseGetmentionLanguages) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseGetmentionLanguages.message;
                })

		    $scope.loadData = function(){
		        $scope.specificLanguages.forEach(function(lang){
		            if(lang.ticked == true){
		                $scope.selectedSpecificLanguageId = lang.id;
		            }
		        })
		        $scope.translateLanguages.forEach(function(lang){
		            if(lang.ticked == true){
		                $scope.selectedTranslateLanguageId = lang.id;
		            }
		        })
		        var data = {
		            specificLanguage: $scope.selectedSpecificLanguageId,
		            translatedLanguage: $scope.selectedTranslateLanguageId,
		            pageNo: $scope.currentPage
		        } 

		        var url_findMention = $scope.currentUrl;
		        $scope.preLoaded = true;
		        $scope.checkedSaveAllMention = false;
		        angular.forEach($scope.specificMentionList, function (item) {
		            item.selected = $scope.checkedSaveAllMention;
		        });

		        $scope.sendHttpPOST(data, url_findMention);
		    }

		    $scope.sendHttpPOST = function(data, url){
		        var req = {
		            url: url,
		            method: 'POST',
		            data: JSON.stringify(data)
		        } 
		        
		        $http(req).success(function (responseSpecificMentionList) {
		            $scope.specificMentionList = responseSpecificMentionList.data;
		            $scope.number = responseSpecificMentionList.totalRow;
		            $scope.enableWatch = true;
		            $scope.pagination();            
		        }) .error(function (data) {
		            });       
		    }    

		    $scope.pagination = function(){
		        $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
		    };

		    $scope.updateTranslationPage = function(val){
		        $scope.currentPage = val;
		        var data = {
		            specificLanguage: $scope.selectedSpecificLanguageId,
		            translatedLanguage: $scope.selectedTranslateLanguageId,
		            pageNo: $scope.currentPage
		        } 

		       var url_findMention = $scope.currentUrl;

		       $scope.sendHttpPOST(data, url_findMention);
		    }

		    $scope.checkedMention = function(index){
		        if ($scope.specificMentionList[index].selected) {
		            $scope.specificMentionList[index].selected = true;
		        } else {
		            $scope.specificMentionList[index].selected = false;
		        }
		        $scope.checkedSaveAllMention = false;
		    }

		    $scope.activeCheckSaveAllMention = function(){        
		        if ($scope.checkedSaveAllMention) {
		            $scope.checkedSaveAllMention = true;
		        } else {
		            $scope.checkedSaveAllMention = false;
		        }
		        angular.forEach($scope.specificMentionList, function (item) {
		            item.selected = $scope.checkedSaveAllMention;
		        });
		    }    

		    $scope.$watch('selectedSpecificLanguage', function(newValue, oldValue) {
		        if(newValue !== oldValue && newValue !== undefined && $scope.enableWatch) {
		        	mentionManagementService.getLanguagesOfInterestingCountries(false)
		                .then(function(response) {
		                	response.data.splice(0, 1);
		                	$scope.translateLanguages = [];
		                    angular.forEach(response.data, function(item) {                        
		                        if(item.id != newValue[0].id) {
		                            item.ticked = false;
		                            $scope.translateLanguages.push(item);
		                        }
		                    })

		                    $scope.translateLanguages[0].ticked = true;
		                    $scope.selectedSpecificLanguageId = newValue[0].id;
		                    $scope.selectedTranslateLanguageId = $scope.translateLanguages[0].id;
		                    var data = {
		                        specificLanguage: $scope.selectedSpecificLanguageId,
		                        translatedLanguage: $scope.selectedTranslateLanguageId,
		                        pageNo: $scope.currentPage
		                    } 

		                    var url_findMention = $scope.currentUrl;
		                    $scope.checkedSaveAllMention = false;
		                    $scope.sendHttpPOST(data, url_findMention);
		                }, function(errResponse) {
		                    var errorModalInstance = $modal.open({
		                        scope: $scope,
		                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                        windowClass: 'modal-dialog-mention-error'
		                    });
		                    $scope.errorModalInstance = errorModalInstance;
		                    $scope.errorMessage = errResponse.message;
		                })
		        }
		    }); 

		    $scope.$watch('selectedTranslatedLanguage', function(newValue, oldValue){
		        if(newValue !== oldValue && newValue !== undefined && $scope.enableWatch){
		            $scope.selectedTranslateLanguageId = newValue[0].id;
		            var data = {
		                specificLanguage: $scope.selectedSpecificLanguageId,
		                translatedLanguage: $scope.selectedTranslateLanguageId,
		                pageNo: $scope.currentPage
		            } 

		           var url_findMention = $scope.currentUrl;
		           $scope.checkedSaveAllMention = false;

		           $scope.sendHttpPOST(data, url_findMention);
		        }
		    }); 

		    $scope.saveTranslation = function(){
		        $scope.checkedMentionList = [];            
		        if($scope.checkedSaveAllMention){
		            $scope.checkedMentionList = $scope.specificMentionList;
		        } else{
		            angular.forEach($scope.specificMentionList, function (value, key) {
		               if ($scope.specificMentionList[key].selected) {   
		                    $scope.checkedMentionList.push($scope.specificMentionList[key]);                                         
		                }            
		            });
		        }

		        var currentRequest = 0;
		        if($scope.checkedMentionList.length == 0){
		            var errorModalInstance = $modal.open({
		                scope: $scope,
		                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                windowClass: 'modal-dialog-mention-error'
		            });
		            $scope.errorModalInstance = errorModalInstance;
		            $scope.errorMessage = "Please choose mention to save.";
		        } else{
		            makeNextRequest();
		        }    
		                
		        function makeNextRequest() {
		            var translatedMentionData = {
		                listOfTranslatedKeyword: $scope.checkedMentionList,
		                translatedLanguageId: $scope.selectedTranslateLanguageId
		            } 

		            var req = {
		                url: $rootScope.apiUrl + 'mention/saveTranslatedMentions',
		                method: 'POST',
		                data: JSON.stringify(translatedMentionData)
		            } 
		            
		              
		            if($scope.checkedMentionList[currentRequest].translatedLanguages[0] == undefined){
		                var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = "Mention '" + $scope.checkedMentionList[currentRequest].keyword + "' has no translation.";

		            } else if($scope.checkedMentionList[currentRequest].translatedLanguages[0] != undefined
		                    && $scope.checkedMentionList[currentRequest].translatedLanguages[0].keyword != ""){
		                var postData = {
		                    keywordId: $scope.checkedMentionList[currentRequest].translatedLanguages[0].id,
		                    keywordName: $scope.checkedMentionList[currentRequest].translatedLanguages[0].keyword,
		                    languageId: $scope.selectedTranslateLanguageId
		                }        
		                var checkTranslatedKeywordUrl = $rootScope.apiUrl + "mention/checkTranslatedKeywordExist";
		                $http.post(checkTranslatedKeywordUrl, postData)
		                .success( function (data){          
		                    currentRequest++;
		                    if (currentRequest < $scope.checkedMentionList.length){
		                        makeNextRequest();
		                    }          
		                    else {
		                        $http(req).success(function (responseSaveTranslatedMentions) {
		                            $scope.loadData();            
		                        }) .error(function (response) {
		                            var errorModalInstance = $modal.open({
		                                        scope: $scope,
		                                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                                        windowClass: 'modal-dialog-mention-error'
		                                    });
		                                    $scope.errorModalInstance = errorModalInstance;
		                                    $scope.errorMessage = response.message;
		                            });  
		                    }  
		                }).error(function (response) {
		                    var errorModalInstance = $modal.open({
		                            scope: $scope,
		                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                            windowClass: 'modal-dialog-mention-error'
		                        });
		                        $scope.errorModalInstance = errorModalInstance;
		                        $scope.errorMessage = response.message;
		                });
		            }                                
		             
		        }                      
		    }

		    $scope.syncData = function(){
		        var url_syncData = $rootScope.apiUrl + 'mention/syncData';
		        $http.get(url_syncData, {loader: false})
		            .success(function(responseSyncData){
		                console.log(responseSyncData);
		            })
		    }   
        }  
])